import Vue from 'vue'
import prepareQueryParamsMixin from '../../mixins/prepareQueryParamsMixin'
import prepareFetchParamsMixin from '../../mixins/prepareFetchParamsMixin'
import OtpInput from '@bachdgvn/vue-otp-input'
import JobService from '../../services/jobService'
import UserService from '../../services/UserService'
import { showErrorToast, showSuccessToast } from '../../services/UI'
Vue.component('v-otp-input', OtpInput)
export default {
  name: 'logoutUserModal',
  mixins: [prepareQueryParamsMixin, prepareFetchParamsMixin],
  data () {
    return {
      mutableActived: this.activated,
      comments: ''
    }
  },
  props: ['activated', 'closeEarningsModal'],
  methods: {
    handleFileChange (e) {
      this.$emit('input', e.target.files[0])
    },
    closeRaject () {
      this.closeEarningsModal(true)
      this.mutableActived = !this.mutableActived
      this.$el.blur()
      this.comment = ''
    },
    async rejectTime () {
      // console.log(this.comments.length)
      if (this.comments.length === 0) {
        showErrorToast(this, 'Comment should not be empty')
        return
      }
      const res = await JobService.cancelMiniJobShiftLog(this.id, this.logId, this.comment)
      if (res) {
        showSuccessToast(this, 'Shift Rejected Successfully')
      } else {
        showErrorToast(this, 'Error Rejecting Shift')
      }
      this.closeRaject()
    },
    async logoutUser () {
      await UserService.logout()
      this.$router.push('/sign_in')
      showSuccessToast(this, 'Logged Out')
    }
  },
  watch: {
    activated (oldVal, newVal) {
      if (oldVal !== newVal && oldVal !== null) {
        this.mutableActived = !this.mutableActived
        this.$el.tabIndex = 1
        this.$nextTick(function () {
          this.$el.focus()
        })
      }
      console.log(this.id, this.logId)
    }
  }
}
